export const strengthColorIndicator = (strength) => {
    switch (strength) {
        case 'Weak':
            return { color: '#fc4e03' }
        case 'Medium':
            return { color: '#fcb812' }
        case 'Strong':
            return { color: 'green' }
        default:
            break;
    }
}
// used with password field in change password component to show the strength of the password